import axios from 'axios';

import { Tag } from '../types/tags';

const API_URL = import.meta.env.VITE_API_URL || 'http://0.0.0.0:8055';

export const fetchTags = async (): Promise<Tag[]> => {
  try {
    const response = await axios.get(`${API_URL}/items/tags`, {
      params: {
        fields: ['translations.*', '*.*'],
      },
    });
    return response.data.data;
  } catch (error) {
    console.error('Error fetching tags:', error);
    throw error;
  }
};
